import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'stateType'
})
export class StateTypePipe implements PipeTransform {
    private prefix = 'stateType';

    constructor() {
    }


    transform(value: any, args?: any): any {

        const toReturn = {
            text: this.prefix + value,
            color: ''
        };
        switch (value) {
            case 1:
                toReturn.color = '#6E3671';
                break;
            case 2:
                toReturn.color = '#A8829F ';
                break;
            case 3:
                toReturn.color = '#92A2A8';
                break;
            case 4:
                toReturn.color = '#a90329';
                break;
            case 5:
                toReturn.color = '#C69021';
                break;
        }
        return toReturn;
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/stateType.pipe.ts